import React from 'react';

const FeatureShowcase = ({ number, total, title, subtitle, items, image, reverse, badgeText, badgeColor }) => {
  return (
    <section 
      id={`feature-${number}`}
      className={`py-16 lg:py-24 transition-colors duration-300 ${reverse ? 'bg-gray-50/50 dark:bg-gray-800/30' : 'bg-white dark:bg-gray-900'}`}
    >
      <div className={`container mx-auto px-4 flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 lg:gap-20`}>
        {/* Text Content */}
        <div className="lg:w-1/2 max-w-lg">
          <div className="inline-block px-3 py-1 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 font-bold text-xs mb-4">
            {number}/{total}
          </div>
          <h2 className="text-3xl lg:text-5xl font-black text-gray-900 dark:text-white mb-4 leading-tight">
            {title}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-8 font-medium">
            {subtitle}
          </p>
          <ul className="space-y-4">
            {items.map((item, i) => (
              <li key={i} className="flex items-start text-lg text-gray-700 dark:text-gray-300 font-medium group">
                <span className="w-7 h-7 mr-3 flex-shrink-0 flex items-center justify-center rounded-full bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-800 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Image/Visual Mockup */}
        <div className="lg:w-1/2 relative w-full max-w-2xl mx-auto lg:mx-0">
          <div className="relative z-10 rounded-3xl overflow-hidden shadow-xl bg-gray-100 dark:bg-gray-800 aspect-[4/3] flex items-center justify-center border-4 border-white dark:border-gray-700">
            {image ? (
              <img src={image} alt={title} className="w-full h-full object-cover" />
            ) : (
              <div className="text-gray-400 dark:text-gray-600 font-bold text-lg">Asset Placeholder</div>
            )}
          </div>
          
          {/* Floating Badge (Figma Style) */}
          {badgeText && (
            <div className={`absolute -top-4 -left-4 z-20 px-6 py-3 rounded-xl shadow-xl text-white font-black text-base transform -rotate-3 ${badgeColor || 'bg-gradient-to-br from-purple-500 to-indigo-600'} border-2 border-white/20 backdrop-blur-sm`}>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-sm bg-white/20 flex items-center justify-center">
                  <div className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></div>
                </div>
                {badgeText}
              </div>
            </div>
          )}

          {/* Decorative Grid/Accents */}
          <div className="absolute inset-0 -m-6 border-2 border-dashed border-gray-100 dark:border-gray-800 rounded-[3rem] -z-10"></div>
        </div>
      </div>
    </section>
  );
};

export default FeatureShowcase;
